<i18n src='../i18n/main.json'></i18n>
<i18n src='../i18n/docs.json'></i18n>
<i18n src='../i18n/doc.json'></i18n>
<template>
<div id="properties" style="position: relative">
  <!-- <flash-message variant="success"></flash-message> -->
  <h1>{{$t(this.$route.params.doctype)}}</h1>

  <doc-form ref="doc_form" :e_doc="e_doc"></doc-form>

  <div class="row">
    <!-- <button v-on:click="loadorderEditor(null, true)" class="btn btn-warning new">{{$t('new_order')}}</button> -->

    <button v-on:click="loadDocEditor();" class="btn btn-warning">
      {{ $t('add_new_doc') }}
    </button>

  </div>
  <br>

  <form v-on:submit.prevent class="form-inline">
    <div class="form-group">
      <label class="form-label" for="page_number">{{$t('browse')}}</label>
      <button v-on:click="pagination.page_number -= 1; loadDocs();" :disabled="pagination.page_number == 1" class="btn btn-default">-</button>
      <input name="page_number" style="width: 70px;text-align: center;" v-on:keyup="keymonitor" type="text" :max="pagination.total_pages"
        v-model="pagination.page_number" :disabled=PageSelectisDisabled class="form-control center">
      <button v-on:click="pagination.page_number += 1; loadDocs();" :disabled="pagination.total_pages == pagination.page_number"
        class="btn btn-default">+</button>
    </div>

    <div class="form-group">
      <label class="form-label" for="filter_client_name">{{$t('client_name')}}</label>
      <input id="filter_client_name" type="text" v-model="filter.client_name" class="form-control">
    </div>
    <!-- <div class="form-group">
      <label class="form-label" for="filter_sku">{{$t('sku')}}</label>
      <input style="width: 100px;" id="filter_sku" type="text" v-model="filter.sku" class="form-control">
    </div> -->

    <div class="form-group">
      <label class="form-label" for="filter_at_gte">{{$t('from')}}-</label>
      <datetime v-model="filter.at_gte" id="filter_at_gte" format="dd/LL/yyyy" auto="true"></datetime>
    </div>

    <div class="form-group">
      <label class="form-label" for="filter_at_lte">{{$t('to')}}-</label>
      <datetime v-model="filter.at_lte" id="filter_at_lte" format="dd/LL/yyyy" auto="true"></datetime>
    </div>

    <div class="form-group">
      <div class="totalPages">
        {{ totalPages }}
      </div>
    </div>
    <div class="form-group">
      <label class="form-label" for="per_page">{{$t('results_in_each_page')}}</label>
      <select style="width: 100px;" name="per_page" v-model="pagination.per_page" class="form-control center">
        <option disabled value="">נא לבחור אפשרות</option>
        <option>10</option>
        <option>25</option>
        <option>50</option>
        <option>100</option>
      </select>
    </div>
  </form>
  <br />
  <!-- <input type="text" v-model="filter.inserted_at" id="date"> -->
  <!-- <p>רשום במערכת כ- { logged_in_email }</p> -->
  <div style="overflow-x:auto">
    <table class="table listing table-striped">
      <thead>
        <tr class="bg alpha">
          <th style="width:100px;text-align:center;">{{$t('number')}}</th>
          <!-- <th>
            <i class="ti-pencil"></i>
          </th> -->
          <th>{{$t('date')}}</th>
          <th>{{$t('client')}}</th>
          <!-- <th>{{$t('meta')}}</th>
          <th>{{$t('paid')}}</th> -->
          <th>{{$t('accounting_ref')}}</th>
          <th>{{$t('total')}}</th>
          <th>{{$t('notes')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="doc of docs" :key="doc.id" v-bind:class="{ pending: doc.status == 0, approved: doc.status == 2 }">
          <td style="text-align:center;">
            <a :href="'/#/docs/' + $route.params.doctype + '/' + doc.id">{{ doc._serial }}</a>
          </td>
          <!-- <td>
            <button v-on:click="loadorderEditor(order, false)" class="btn btn-warning">{{$t('edit')}}</button>
          </td> -->
          <td dir="ltr">
            <a :href="'/#/docs/' + $route.params.doctype + '/' +  doc.id">{{ $moment(doc.at).format('DD/MM/YYYY') }}</a>
          </td>
          <td>
            <a class="disabled" :href="'/#/clients/' + doc.client_id" style="width: 100%;display: block;">
              {{ doc.client_name }}
            </a>
          </td>
          <!-- <td>{{ order.meta }}</td>
          <td>{{ order.paid }}</td> -->
          <td>{{ doc.accounting_ref }}</td>
          <td>{{ parseFloat(doc.total).toFixed(2) }}</td>
          <td>{{ doc.notes }}</td>
        </tr>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
Vue.use(VueLodash)

import DocForm from '../components/DocForm'

export default {
  components: {
    'doc-form': DocForm
  },
  data() {
    return {
      doctype: null,
      doctypes: {
        orders: 1,
        price_quotes: 2
      },
      // order: [{ id: null, itemlines: [] }],
      clients_options: [],
      items_options: [],
      vendors: [],
      adding_order: false,
      e_doc: this.init_doc(),
      docs: [],
      errors: [],
      filter: {
        at: '',
        client_id: '',
        //inserted_at: moment().format('YYYY-MM-DD')
        inserted_at: '2017-10-01'
      },
      filter_objects: [],
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      pagination: {
        page_number: '',
        total_pages: '',
        per_page: '100'
      },
      PageSelectisDisabled: false,
      // paymentMethods: {
      //   cash: this.$t('cash'),
      //   credit_card: this.$t('credit_card'),
      //   bank_transfer: this.$t('bank_transfer')
      // },
      metaOptions: null,
      dataReady: true
    }
  },
  computed: {
    tokenState() {
      return this.$ls.get('access_token')
    },
    totalPages() {
      return this.pagination.total_pages
    },
    Agent() {
      return this.$ls.get('agent')
    },
    locale() {
      return this.$store.getters.locale
    }
  },
  created() {
    this.init()
  },
  watch: {
    $route(to, from) {
      //this.show = false
      this.init()
    },
    locale(locale) {
      this.$i18n.locale = locale
      this.loadTranslations()
    },
    'filter.client_name': function(val, oldVal) {
      this.loadDocs()
    },
    // 'filter.sku': function(val, oldVal) {
    //   this.loadDocs()
    // },
    'filter.vendor_id': function(val, oldVal) {
      this.loadDocs()
    },
    'filter.at_gte': function(val, oldVal) {
      this.loadDocs()
    },
    'filter.at_lte': function(val, oldVal) {
      this.loadDocs()
    },

    // 'filter.user_id': function(val, oldVal) {
    //   this.loadDocs()
    // },
    // 'pagination.per_page': function(val, oldVal) {
    //   this.loadDocs()
    // },
    docs: function(val, oldVal) {
      this.PageSelectisDisabled = false
    }
  },

  methods: {
    init: function() {
      this.doctype = this.doctypes[this.$route.params.doctype] == null ? 0 : this.doctypes[this.$route.params.doctype]
      this.loadDocs()
      this.$i18n.locale = this.$store.getters.locale
      this.$i18n.silentTranslationWarn = true
      this.loadTranslations()
      this.metaOptions = this.G_metaOptions()
    },
    itemInfo: function(item_data) {
      return typeof item_data.sku !== 'undefined'
        ? `
      <div dir="ltr" style='text-align:left;'>${item_data.sku}</div>
      <div dir="${this.hasUnicode(item_data.item_name) ? 'rtl' : 'ltr'}" style='text-align:${
            this.hasUnicode(item_data.item_name) ? 'right' : 'left'
          };'>
      ${item_data.item_name}
      </div>
      <div dir="rtl" style='text-align:right;'>${item_data.vendor_name}</div>
      `
        : null
    },
    dateFormatter(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a')
    },
    init_doc: function() {
      return {
        isNew: true,
        client_id: null,
        client_id_processing: null,
        status: null,
        meta: null,
        accounting_ref: null,
        notes: null,
        itemlines: [],
        at: this.$moment().format('YYYY-MM-DD')
      }
    },

    loadDocs: function(e) {
      var vm = this
      console.log(vm.authorization())
      console.log(vm.doctype)
      vm.PageSelectisDisabled = true
      vm.$axios
        .get(`/api/docs`, {
          headers: vm.authorization(),
          params: {
            page: vm.pagination.page_number,
            per_page: vm.pagination.per_page,
            at: vm.filter.at,
            //client_id: vm.filter.client_id,
            client_name: vm.filter.client_name,
            at_gte: vm.filter.at_gte,
            at_lte: vm.filter.at_lte,
            doctype: vm.doctype
          }
        })
        .then(response => {
          console.log(response.data)
          // JSON responses are automatically parsed.
          vm.docs = response.data.docs.entries

          vm.pagination.page_number = response.data.docs.page_number
          vm.pagination.total_pages = response.data.docs.total_pages
          if (vm.pagination.page_number > vm.pagination.total_pages) {
            vm.pagination.page_number = 1
            vm.loadDocs()
          }
        })
        .catch(e => {
          vm.errors.push(e)
          vm.PageSelectisDisabled = false
        })
    },

    add_book: function() {
      this.adding_order = !this.adding_order
    },
    loadTranslations: function() {
      this.click_to_print_sticker = this.$t('click_to_print_sticker')
      this.number_of_results_pages = this.$t('number_of_results_pages')
      this.days_count = this.$t('days_count')
    },

    keymonitor: function(event) {
      if (event.key == 'Enter') {
        this.loadDocs()
      }
    },

    loadDocEditor: function() {
      this.$refs.doc_form.$refs.edit_doc_modal.open()
    },

    loadFilterObjects: function(e) {
      this.$axios
        .get(`/api/docs/filter_objects`, {
          headers: {
            authorization: this.$ls.get('access_token')
          }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          this.filter_objects = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    updateRow: function(row) {
      var foundIndex = this.properties.findIndex(x => x.id == row.id)
      this.$set(this.properties, foundIndex, row)
    }
  }
}
</script>

<style lang="scss">
@import './sass/docs.scss';
</style>
